let dirPath = 'static/games/page002_game3';

let configGame = {
  removeInCorrects: false,
  correctBlock: false,
  //autoCheckAllCorrect: true,
  rulesGame: {
    itemsConfig: { shuffle: false },
    itemsGarbage: [{ idGroup: 'checks', itemsConfig: { block: false } }],
    otherProperty: {
      sounds: [{ src: dirPath + '/audio/klik.mp3', id: 'mouseup' }],
    },
    items: [
      { idGroup: 'checks', idItem: 's00', correct: [{ idGroup: 'checks', idItem: 's00' }] },
      { idGroup: 'checks', idItem: 's01', correct: [{ idGroup: 'checks', idItem: 's01' }] },
      { idGroup: 'checks', idItem: 's02', correct: [{ idGroup: 'checks', idItem: 's02' }] },
      { idGroup: 'checks', idItem: 's03', correct: [{ idGroup: 'checks', idItem: 's03' }] },
      { idGroup: 'checks', idItem: 's04', correct: [{ idGroup: 'checks', idItem: 's04' }] },
    ],
  },
  layout: {
    groups: [
      {
        idGroup: 'checks',
        positions: { pos: { x: 0, y: -50 } },
        itemsConfig: {
          background: {
            color: 'rgba(255,255,255,0.01)',
          },
          positions: {
            type: 'absolute',
            pos: { width: 93, height: 93 },
          },
        },
        otherProperty: {
          pair: {
            check: {
              positions: { pos: { width: 93, height: 93 } },
              background: { image: { src: dirPath + '/img/select.png' } },
            },
          },
        },
        items: [
          {
            id: 's00',
            positions: { pos: { x: 1030, y: 240 } },
          },
          {
            id: 's01',
            positions: { pos: { x: 1115, y: 475 } },
          },
          {
            id: 's02',
            positions: { pos: { x: 1250, y: 425 } },
          },
          {
            id: 's03',
            positions: { pos: { x: 1440, y: 450 } },
          },
          {
            id: 's04',
            positions: { pos: { x: 1450, y: 75 } },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  mixinEngine: 'select',
  realHeight: 890,
  realWidth: 1700,
  configGame: configGame,
  mainImage: {
    imagePath: dirPath + '/img/bgr.jpg',
  },
};

export default dataConfig;
